import { render, staticRenderFns } from "./BacInput.vue?vue&type=template&id=3b8fd4c6&scoped=true&"
import script from "./BacInput.vue?vue&type=script&lang=ts&"
export * from "./BacInput.vue?vue&type=script&lang=ts&"
import style0 from "./BacInput.vue?vue&type=style&index=0&id=3b8fd4c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8fd4c6",
  null
  
)

export default component.exports